/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_patch_league_matches_bulk_matches_v2_league_bulk_patch = {
    properties: {
        match_ids: {
            type: 'array',
            contains: {
                type: 'number',
            },
            isRequired: true,
        },
        match_league_patch: {
            type: 'MatchLeaguePatchAdmin',
            isRequired: true,
        },
    },
} as const;
